export default "__VITE_ASSET__Dcg2TGtm__"